$(document).ready(function(){
  //instagram
  var $slider1 = $('.slider_box-insta .lp_slider > .shg-row');
  var $progressBar1 = $('.lp-insta__progress');
  var $progressBarLabel1 = $( '.lp-insta__label' );
  var $itemToShow = 4;
  
  $slider1.on('init', function(event, slick, currentSlide, nextSlide) {   
    
    var calc = ( (1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;

    $progressBar1
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel1.text( calc + '% completed' );
  });
  
  $slider1.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    console.log(slick.slideCount, slick.options.slidesToShow);
    var calc = ( (nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;

    $progressBar1
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel1.text( calc + '% completed' );
  });
  
  $slider1.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    draggable: true,
    variableWidth: false,
    appendArrows: '.lp-insta__arrow',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          variableWidth: true,
          slidesToShow: 2
        }
      }
    ]
  });
  
  //blog
  var $slider2 = $('.slider_box-blog .lp_slider > .shg-row');
  var $progressBar2 = $('.lp-blog__progress');
  var $progressBarLabel2 = $( '.lp-blog__label' );
  var $itemToShow2 = 4;
  
  $slider2.on('init', function(event, slick, currentSlide, nextSlide) {   
    
    var calc = ( (1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;

    $progressBar2
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel2.text( calc + '% completed' );
  });
  
  $slider2.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    console.log(slick.slideCount, slick.options.slidesToShow);
    var calc = ( (nextSlide + 1) / ((slick.slideCount + 1) - (slick.options.slidesToShow)) ) * 100;

    $progressBar2
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel2.text( calc + '% completed' );
  });
  
  $slider2.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    draggable: true,
    variableWidth: false,
    appendArrows: '.lp-blog__arrow',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          variableWidth: true,
          slidesToShow: 2
        }
      }
    ]
  });
  
  $('.shogun-root a[href^="#"]').on("click", function (event) {
    event.stopImmediatePropagation();
    try{
      var adjust = $('#section-header').innerHeight();
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - adjust;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    }
    catch(err){
       console.log(err.message);
    }
  })
});
  
